// extracted by mini-css-extract-plugin
export default {"booleanInput":"CustomFormBoolean_booleanInput__I3jCZ"};